import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import { useNavigate } from "react-router-dom";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Package, User } from "react-feather";
import Barchart from "./AdminComp/Barchart";
import { baseurl } from "../../Baseurl";
import axios from "axios";
import AnalyticsNavbar from "./AnalyticsNavbar";
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function AdminDashboard() {
  const [stats, setStats] = useState({
    total_products: 0,
    total_price: 0,
    total_sellers: 0,
    total_users: 0,
    total_categories: 0,
    total_enquiries: 0,
  });

  const [orderStatusCounts, setOrderStatusCounts] = useState([]);
 const total = orderStatusCounts.reduce((sum, item) => sum + item.count, 0);



const [listings, setListings] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalCost, setTotalCost] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
      const fetchListings = async () => {
        try {
          const response = await axios.get(`${baseurl}getAllSellerListingsadmin`);
          if (response.data.success) {
            const data = response.data.data;
  
            setListings(data);
            setFilteredData(data);
  
            const cost = data.reduce((acc, item) => {
              const qty = item.quantity || 0;
              const price = parseFloat(item.price) || 0;
              return acc + qty * price;
            }, 0);
            setTotalCost(cost);
          }
        } catch (error) {
          console.error("Error fetching listings:", error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchListings();
    }, []);


  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get(`${baseurl}getProductStats`);
        if (res.data && res.data.data) {
          setStats(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching stats:", err);
      }
    };

    const fetchOrderStatuses = async () => {
      try {
        const res = await axios.get(`${baseurl}getAllSellerStatusCounts`);
        if (res.data && res.data.success) {
          setOrderStatusCounts(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching order statuses:", err);
      }
    };

    fetchStats();
    fetchOrderStatuses();
  }, []);

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          {/* <AnalyticsNavbar/> */}

          <div className="crdmain mb-2">
            <div className="  justify-content-between align-items-center">
              <h2 className="chart-title text-start">Welcome to Dashboard</h2>
            </div>

            <div className="row g-2 mt-0 mb-0">
              <div className="col-md-2">
                <Link to="/admin/all-listings">
                  <div className="ag1 bgg2 p-2 text-start">
                    <div className="ag4 mb-3">
                      <span className="agsvg1 bbg2 p-2">
                        <User />
                      </span>
                    </div>
                    <div className="ag2 font4 text-dark">
                      {stats.total_products}
                    </div>
                    <div className="ag3 font4 text-dark">Total Listings</div>
                  </div>
                </Link>
              </div>

              <div className="col-md-2">
                <Link to="/admin/all-sellers">
                  <div className="ag1 bgg3 p-2 text-start">
                    <div className="ag4 mb-3">
                      <span className="agsvg1 bbg3 p-2">
                        <User />
                      </span>
                    </div>
                    <div className="ag2 font4 text-dark">
                      {stats.total_sellers}
                    </div>
                    <div className="ag3 font4 text-dark">Total Sellers</div>
                  </div>
                </Link>
              </div>

              <div className="col-md-2">
                <Link to="/admin/all-customer">
                  <div className="ag1 bgg4 p-2 text-start">
                    <div className="ag4 mb-3">
                      <span className="agsvg1 bbg4 p-2">
                        <User />
                      </span>
                    </div>
                    <div className="ag2 font4 text-dark">
                      {stats.total_users}
                    </div>
                    <div className="ag3 font4 text-dark">Total Customers</div>
                  </div>
                </Link>
              </div>

              <div className="col-md-2">
                <Link to="/admin/active-category">
                  <div className="ag1 bgg1 p-2 text-start">
                    <div className="ag4 mb-3">
                      <span className="agsvg1 bbg1 p-2">
                        <User />
                      </span>
                    </div>
                    <div className="ag2 font4 text-dark">
                      {stats.total_categories}
                    </div>
                    <div className="ag3 font4 text-dark">Total Categories</div>
                  </div>
                </Link>
              </div>

              <div className="col-md-4">
                <Link to="/admin/all-listings-cost">
                  <div className="ag1 bgg1 p-2 text-start">
                    <div className="ag4 mb-3">
                      <span className="agsvg1 bbg1 p-2">
                        <User />
                      </span>
                    </div>
                    <div className="ag2 font4 text-dark">
                      ₹
                      {totalCost.toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </div>
                    <div className="ag3 font4 text-dark">
                      Listing Total Cost
                    </div>
                  </div>
                </Link>
              </div>
            </div>

            <div className="row g-2 mt-2">
              <div className="col-md-6">
                <div className="row g-2 mt-2" >
                <div className="col-md-6">
                  <Link to="/admin/all-enquiry">
                    <div className="ag1 bgg1 p-2 text-start">
                      <div className="ag4 mb-3">
                        <span className="agsvg1 bbg1 p-2">
                          <User />
                        </span>
                      </div>
                      <div className="ag2 font4 text-dark">
                        {stats.total_enquiries}
                      </div>
                      <div className="ag3 font4 text-dark">
                        All Seller's Inquiry
                      </div>
                    </div>
                  </Link>
                </div>

                {orderStatusCounts.map((statusObj, idx) => (
                  <div className="col-md-6" key={idx}>
                    <Link to="/admin/all-orders">
                      <div className="ag1 bgg1 p-2 text-start">
                        <div className="ag4 mb-3">
                          <span className="agsvg1 bbg1 p-2">
                            <Package />
                          </span>
                        </div>
                        <div className="ag2 font4 text-dark">
                          {statusObj.count}
                        </div>
                        <div className="ag3 font4 text-dark text-capitalize">
                          {statusObj.status}
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
              </div>
              <div className="col-md-6 text-center">
<div className="col-md-12 " >
  {orderStatusCounts.length > 0 && (
    <>
      <div style={{ position: ' ', height: '100%', minHeight: '300px', width: '100%' }}>
        <Pie  style={{ position: ' ', height: '100%', minHeight: '450px', width:'400px' }}
          data={{
            labels: orderStatusCounts.map((item) => item.status),
            datasets: [
              {
                data: orderStatusCounts.map((item) => Number(item.count)),
                backgroundColor: [
                  '#FF6384',
                  '#36A2EB',
                  '#FFCE56',
                  '#4BC0C0',
                  '#9966FF',
                  '#FF9F40'
                ],
                borderWidth: 1,
                cutout: '50%', // donut effect
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false, // 🔑 Enables full width/height
            plugins: {
              tooltip: {
                callbacks: {
                  label: function (context) {
                    const values = context.dataset.data;
                    const total = values.reduce((acc, val) => acc + Number(val), 0);
                    const value = Number(context.raw);
                    const percentage = ((value / total) * 100).toFixed(1);
                    return `${context.label}: ${percentage}% (${value})`;
                  },
                },
              },
              legend: {
                position: 'bottom',
              },
            },
          }}
        />
      </div>

      {/* Percent list below */}
      {/* <div className="mt-3">
        {(() => {
          const total = orderStatusCounts.reduce((sum, item) => sum + Number(item.count), 0);
          return orderStatusCounts.map((item, idx) => {
            const percent = ((Number(item.count) / total) * 100).toFixed(1);
            return (
              <div key={idx} className="d-flex justify-content-between px-2">
                <span><strong>{item.status}</strong></span>
                <span>{percent}%</span>
              </div>
            );
          });
        })()}
      </div> */}
    </>
  )}
</div>


</div>    
            </div>


          </div>

          {/* Bar Chart */}
          <div className="crdmain mb-2">
            <div className="row">
              <div className="col">
                <Barchart />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
